import { render, staticRenderFns } from "./PortabilityRequestsLoader.vue?vue&type=template&id=1c34e912&scoped=true&"
import script from "./PortabilityRequestsLoader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PortabilityRequestsLoader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PortabilityRequestsLoader.vue?vue&type=style&index=0&id=1c34e912&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c34e912",
  null
  
)

export default component.exports